// 在线选课
const onlineChoseClass = () => import( /* webpackChunkName: "basic" */ '@/pages/csmsTimeTable/views/onlineCourseSelection/SelectList.vue')
//在线选课-走班选课
const choseCourse = () => import( /* webpackChunkName: "basic" */ '@/pages/csmsTimeTable/views/onlineCourseSelection/choseCourse.vue')
//在线选课-走班选课结果
const coursePreview = () => import( /* webpackChunkName: "basic" */ '@/pages/csmsTimeTable/views/onlineCourseSelection/choseCoursePreview.vue')
//在线选课-校本抢课简单模式
const choseCourseSchoolBase = () => import( /* webpackChunkName: "basic" */ '@/pages/csmsTimeTable/views/onlineCourseSelection/choseCourseSchoolBase.vue')
//在线选课-校本抢课简单模式结果
const choseCourseSchoolBasePreview = () => import( /* webpackChunkName: "basic" */ '@/pages/csmsTimeTable/views/onlineCourseSelection/choseCourseSchoolBasePreview.vue')
//在线选课-校本抢课分组模式
const choseCourseSchoolBaseGroup = () => import( /* webpackChunkName: "basic" */ '@/pages/csmsTimeTable/views/onlineCourseSelection/choseCourseSchoolBaseGroup.vue')
//在线选课-校本抢课分组模式结果
const choseCourseSchoolBasePreviewGroup = () => import( /* webpackChunkName: "basic" */ '@/pages/csmsTimeTable/views/onlineCourseSelection/choseCourseSchoolBasePreviewGroup.vue')
//在线选课-分层选课
const layeredSelect = () => import( /* webpackChunkName: "basic" */ '@/pages/csmsTimeTable/views/onlineCourseSelection/layered/onlineCourseSelect.vue')
const layeredPreview = () => import( /* webpackChunkName: "basic" */ '@/pages/csmsTimeTable/views/onlineCourseSelection/layered/onlineCoursePreview.vue')
//代课申请
const substituteTable = () => import( /* webpackChunkName: "basic" */ '@/pages/csmsTimeTable/views/adjustSubstitute/apply/SubstituteTable.vue')
const substituteCreate = () => import( /* webpackChunkName: "basic" */ '@/pages/csmsTimeTable/views/adjustSubstitute/apply/SubstituteCreate.vue')
const applyDetail = () => import( /* webpackChunkName: "basic" */ '@/pages/csmsTimeTable/views/adjustSubstitute/apply/Detail.vue')
//调课申请
const adjustTable = () => import( /* webpackChunkName: "basic" */ '@/pages/csmsTimeTable/views/adjustSubstitute/apply/AdjustTable.vue')
const adjustCreate = () => import( /* webpackChunkName: "basic" */ '@/pages/csmsTimeTable/views/adjustSubstitute/apply/AdjustCreate.vue')
//审批列表
const approvaltTable = () => import( /* webpackChunkName: "basic" */ '@/pages/csmsTimeTable/views/adjustSubstitute/approval/AdjustTable.vue')
const approvaltDetail = () => import( /* webpackChunkName: "basic" */ '@/pages/csmsTimeTable/views/adjustSubstitute/approval/AdjustDetails.vue')
//申请记录
const recordTable = () => import( /* webpackChunkName: "basic" */ '@/pages/csmsTimeTable/views/applyRecord/RecordTable.vue')
const applyRecord = () => import( /* webpackChunkName: "basic" */ '@/pages/csmsTimeTable/views/applyRecord/ApplyRecord.vue')
//
const mySchedule = () => import( /* webpackChunkName: "basic" */ '@/pages/csmsTimeTable/views/mySchedule/MySchedule.vue')
const OnlineClass = () => import( /* webpackChunkName: "basic" */ '@/pages/csmsTimeTable/views/onlineClass/OnlineClass.vue')
const OnlineTeaching = () => import( /* webpackChunkName: "basic" */ '@/pages/csmsTimeTable/views/onlineTeaching/OnlineTeaching.vue')
//
const myStudents = () => import( /* webpackChunkName: "basic" */ '@/pages/csmsTimeTable/views/myStudents/MyStudents.vue')
const myStudentsList = () => import( /* webpackChunkName: "basic" */ '@/pages/csmsTimeTable/views/myStudents/MyStudentsList.vue')
//
const scheduleChanges = () => import( /* webpackChunkName: "basic" */ '@/pages/csmsTimeTable/views/scheduleChanges/ScheduleChanges.vue')
const ApprovalTable = () => import( /* webpackChunkName: "basic" */ '@/pages/csmsTimeTable/views/scheduleChanges/adjustSubstituteApproval/ApprovalTable.vue')  //课表变动
const AdjustDetails = () => import( /* webpackChunkName: "basic" */ '@/pages/csmsTimeTable/views/scheduleChanges/adjustSubstituteApproval/AdjustDetails.vue')
const ApprovalDetails = () => import( /* webpackChunkName: "basic" */ '@/pages/csmsTimeTable/views/scheduleChanges/adjustSubstituteApproval/ApprovalDetails.vue')
const SubsituteDetails = () => import( /* webpackChunkName: "basic" */ '@/pages/csmsTimeTable/views/scheduleChanges/adjustSubstituteApproval/SubsituteDetails.vue')

const csmstimetable = [
  // csmsTimeTable router
  {
    path: 'onlineChoseClass',
    name: 'onlineChoseClass',
    component: onlineChoseClass,
  },
  {
    path: 'choseCourse',
    name: 'choseCourse',
    component: choseCourse,
  },
  {
    path:'coursePreview',
    name: 'coursePreview',
    component: coursePreview,
  },
  {
    path: 'choseCourseSchoolBase',
    name: 'choseCourseSchoolBase',
    component: choseCourseSchoolBase,
  },
  {
    path:'choseCourseSchoolBasePreview',
    name: 'choseCourseSchoolBasePreview',
    component: choseCourseSchoolBasePreview,
  },
  {
    path: 'choseCourseSchoolBaseGroup',
    name: 'choseCourseSchoolBaseGroup',
    component: choseCourseSchoolBaseGroup,
  },
  {
    path:'choseCourseSchoolBasePreviewGroup',
    name: 'choseCourseSchoolBasePreviewGroup',
    component: choseCourseSchoolBasePreviewGroup,
  },
  //分层选课
  {
    path:'layeredSelect',
    name: 'layeredSelect',
    component: layeredSelect,
  },
  {
    path:'layeredPreview',
    name: 'layeredPreview',
    component: layeredPreview,
  },
  //代课申请
  {
    path: 'substituteTable',
    name: 'substituteTable',
    component: substituteTable,
  },
  {
    path: 'substituteCreate',
    name: 'substituteCreate',
    component: substituteCreate,
  },
  {
    path: 'applyDetail',
    name: 'applyDetail',
    component: applyDetail,
  },
  //调课申请
  {
    path: 'adjustTable',
    name: 'adjustTable',
    component: adjustTable,
  },
  {
    path: 'adjustCreate',
    name: 'adjustCreate',
    component: adjustCreate,
  },
  //审批列表
  {
    path: 'approvaltTable',
    name: 'approvaltTable',
    component: approvaltTable,
  },
  {
    path: 'approvaltDetail',
    name: 'approvaltDetail',
    component: approvaltDetail,
  },
  //申请记录
  {
    path: 'recordTable',
    name: 'recordTable',
    component: recordTable,
  },
  {
    path: 'applyRecord',
    name: 'applyRecord',
    component: applyRecord,
  },
  /*申请记录end*/
  {
    path: 'mySchedule',
    name: 'mySchedule',
    component: mySchedule,
  },
  {
    path: 'OnlineClass',
    name: 'OnlineClass',
    component: OnlineClass,
  },
  {
    path: 'OnlineTeaching',
    name: 'OnlineTeaching',
    component: OnlineTeaching,
  },
  {
    path: 'myStudents',
    name: 'myStudents',
    component: myStudents,
  },
  {
    path: 'myStudentsList',
    name: 'myStudentsList',
    component: myStudentsList,
  },
  {
    path: 'scheduleChanges',
    name: 'scheduleChanges',
    component: scheduleChanges,
  },
  {
    path: 'ApprovalTable',
    name: 'ApprovalTable',
    component: ApprovalTable,
  },
  {
    path: 'AdjustDetails',
    name: 'AdjustDetails',
    component: AdjustDetails,
  },
  {
    path: 'ApprovalDetails',
    name: 'ApprovalDetails',
    component: ApprovalDetails,
  },
  {
    path: 'SubsituteDetails',
    name: 'SubsituteDetails',
    component: SubsituteDetails,
  },
]
export default csmstimetable;
